
import { defineComponent, onBeforeMount, ref } from 'vue';
import { VueEditor } from 'vue2-editor';
// import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';

// import EssentialsPlugin from '@ckeditor/ckeditor5-essentials/src/essentials';
// import BoldPlugin from '@ckeditor/ckeditor5-basic-styles/src/bold';
// import ItalicPlugin from '@ckeditor/ckeditor5-basic-styles/src/italic';
// import LinkPlugin from '@ckeditor/ckeditor5-link/src/link';
// import ParagraphPlugin from '@ckeditor/ckeditor5-paragraph/src/paragraph';
import axios, { AxiosError } from 'axios';
import { getTaskById, saveTask } from '@/utils/admin/task_management_service';
import { invokeGetUserRole } from '@/utils/admin/master_service';

export default defineComponent({
  name: 'TaskDetails',
  components: { VueEditor },
  // props: ['query'],
  props: {
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const showScreen = ref(true);
    const showUpdate = ref(true);
    const loggedInUserRoles = ref();
    const loggedInUser = ref();
    const taskId = ref(props.query.task_id);
    const renderReady = ref(true);
    const taskDetails = ref();
    const showSuccessMessage = ref(false);
    const resMessage = ref();
    const showErrorMessage = ref(false);
    const editorConfig = ref({});
    const getTaskdetails = async () => {
      const defaultLikertScale = {
        poor: 'Poor',
        below_average: 'Below Average',
        average: 'Average',
        above_average: 'Above Average',
        excellent: 'Excellent',
      };
      renderReady.value = false;
      taskDetails.value = await getTaskById(taskId.value);
      taskDetails.value.likertScale = taskDetails.value.likertScale ? taskDetails.value.likertScale : defaultLikertScale;
      console.log('Task Response', taskDetails.value);
      renderReady.value = true;
    };
    // const saveTask = async () => {
    //   console.log(`inside saveTask task details ${taskDetails.value}`);
    // };
    const updateRecord = async () => {
      try {
        renderReady.value = false;
        if (taskDetails.value?.genAiAssistMaxAttempts) taskDetails.value.genAiAssistMaxAttempts = parseInt(taskDetails.value?.genAiAssistMaxAttempts, 10);
        console.log(`inside updateRecord task details ${JSON.stringify(taskDetails.value)}`);
        const res = await saveTask(taskDetails.value);
        resMessage.value = res.data?.message;
        renderReady.value = true;
        showSuccessMessage.value = true;
        window.scroll(0, 0);
        renderReady.value = true;
      } catch (error) {
        renderReady.value = true;
        if (axios.isAxiosError(error)) {
          const err = error as AxiosError;
          // console.log(err.response?.data);
          renderReady.value = true;
          resMessage.value = (err.response?.data as { message: string })?.message;
          // console.log(`errorMessage.value ${errorMessage.value}`);
          showErrorMessage.value = true;
          setTimeout(() => {
            showErrorMessage.value = false;
          }, 2000);
        }
      }
    };
    onBeforeMount(async () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const role: any = await invokeGetUserRole('/getUserRole');
      loggedInUserRoles.value = role.user_roles;
      loggedInUser.value = role.user_key;
      if (loggedInUserRoles.value.length > 0) {
        if (loggedInUserRoles.value.includes('System Admin') || loggedInUserRoles.value.includes('Community Manager') || loggedInUserRoles.value.includes('Program Admin')) {
          showUpdate.value = true;
          showScreen.value = true;
        } else if (loggedInUserRoles.value.includes('System Admin View Access')) {
          showScreen.value = true;
          showUpdate.value = false;
        } else {
          showUpdate.value = false;
          showScreen.value = false;
        }
      }
      await getTaskdetails();
    });
    return {
      taskId,
      renderReady,
      taskDetails,
      updateRecord,
      showSuccessMessage,
      resMessage,
      showErrorMessage,
      showUpdate,
      editorConfig,
      showScreen,
    };
  },
});
